<template>
  <div class="place-list">
    <search-criteria @nearbySearch="nearbySearch" @back="back"></search-criteria>
    <h1 v-if="emptyResult">Nichts gefunden</h1>
    <ul>
      <nearby-list-item
        @deletePlace="removePlace"
        @showPlace="showPlace"
        v-for="place in nearbyPlaces"
        :key="place.id"
        :place="place"
      ></nearby-list-item>
    </ul>
  </div>
</template>

<script>
import NearbyListItem from "../../components/places/NearbyListItem.vue";
import SearchCriteria from "../../components/places/SearchCriteria";
import createPlaceMixin from "../../mixins/createPlace.js";

export default {
  components: {
    NearbyListItem,
    SearchCriteria,
  },
  data() {
    return {
      emptyResult: false,
      placeToEdit: null,
    };
  },
  computed: {
    center() {
      return this.$store.getters.center;
    },
    nearbyPlaces() {
      return this.$store.getters.nearbyPlaces;
    },
  },
  mixins: [createPlaceMixin],
  methods: {
    removePlace(id) {
      this.$store.dispatch("removeNearbyPlace", id);
    },
    async showPlace(id) {
      let nearbyPlaces = this.$store.getters.nearbyPlaces;
      this.placeToEdit = nearbyPlaces.find((p) => p.id === id);
      try {
        const googlePlace = new window.google.maps.places.Place({ id });
        await googlePlace.fetchFields({
          fields: [
            "websiteURI",
            "internationalPhoneNumber",
            "formattedAddress",
          ],
        });
        this.placeToEdit.link = googlePlace.websiteURI ?? "";
        this.placeToEdit.phone = googlePlace.internationalPhoneNumber ?? "";
        this.placeToEdit.address = googlePlace.formattedAddress ?? "";
        this.$store.dispatch("updateNearbyPlace", this.placeToEdit);
        this.$router.push(`/places/nearby/${this.placeToEdit.id}`);
      } catch (error) {
        console.error("Failed to load place details", error);
      }
    },
    async nearbySearch(radius, type) {
      this.$store.dispatch("setNearbyPlaces", []);
      this.emptyResult = false;

      const request = {
        fields: [
          "displayName",
          "location",
          "businessStatus",
          "types",
          "id",
          "photos",
          "formattedAddress",
        ],
        locationRestriction: {
          center: this.center,
          radius: Number(radius),
        },
        includedTypes: [type],
      };

      try {
        const { places } = await window.google.maps.places.Place.searchNearby(
          request
        );
        const lat = this.center.lat();
        const lng = this.center.lng();
        const operational = window.google.maps.places.BusinessStatus.OPERATIONAL;
        let placesFound = [];

        for (let result of places ?? []) {
          if (result.businessStatus === operational) {
            const place = this.createPlace(result);
            if (!place) continue;
            const dist = place.distTo(lat, lng);
            const kmDist = dist / 1000;
            const km = kmDist > 25 ? kmDist.toFixed(0) : kmDist.toFixed(2);
            place.nearbyDistance = km + " km";
            placesFound.push(place);
          }
        }
        placesFound.sort((p1, p2) => {
          return p1.distTo(lat, lng) - p2.distTo(lat, lng);
        });
        this.$store.dispatch("setNearbyPlaces", placesFound);
      } catch (error) {
        console.error("Nearby search failed", error);
      }
      this.emptyResult = this.nearbyPlaces.length == 0;
    },
    back() {
      this.$router.push("/map")
    },
  },
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}

.place-list {
  background-color: white;
}

@media (min-width: 768px) {
  .place-list {
    min-width: 768px;
    max-width: 90vw;
    margin: auto;
  }
}
</style>
